import { render, staticRenderFns } from "./CreatingModal.vue?vue&type=template&id=64a5af58&"
import script from "./CreatingModal.vue?vue&type=script&lang=js&"
export * from "./CreatingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports